/**
 * More Menu Panel Plugin for Search Results Map
 *
 * Adds "click outside to close" behaviour to the mobile more-menu panel
 * (.nhs-c-map__more-menu-panel). The panel itself is CSS-driven through a
 * checkbox toggle; this plugin simply unchecks that toggle whenever the user
 * clicks anywhere in the document that is not inside the panel or on the
 * button that opens it.
 *
 * Single responsibility: dismiss the more-menu panel on outside clicks.
 *
 * This plugin does NOT:
 * - Control what is rendered inside the panel (see MoreMenuPanel.cshtml)
 * - Handle road/satellite switching (see mapTypeToggle.plugin)
 * - Manage the advanced-filters panel (see advancedFiltersPanel.js)
 *
 * Reason to change: the selector used to identify the panel or the toggle,
 * or the dismissal trigger needs to change.
 *
 * @module searchResultsMap/plugins/moreMenuPanel.plugin
 */

const MORE_MENU_TOGGLE_SELECTOR = '[data-more-menu-toggle]';
const MORE_MENU_PANEL_SELECTOR = '[data-more-menu-panel]';
const MORE_MENU_BUTTON_SELECTOR = '[data-more-menu-button]';

export default function createMoreMenuPanelPlugin() {
  const state = {
    started: false,
    toggle: null,
  };

  function handleDocumentClick(event) {
    if (!state.toggle?.checked) {
      return;
    }

    const clickedInsideMenu = !!event.target.closest(
      `${MORE_MENU_TOGGLE_SELECTOR}, ${MORE_MENU_BUTTON_SELECTOR}, ${MORE_MENU_PANEL_SELECTOR}`,
    );

    if (!clickedInsideMenu) {
      state.toggle.checked = false;
    }
  }

  return {
    name: 'more-menu-panel',

    async init(context) {
      context.state.moreMenuPanel = { started: false };
    },

    async start(context) {
      if (state.started) {
        return;
      }

      state.toggle = document.querySelector(MORE_MENU_TOGGLE_SELECTOR);

      if (!state.toggle) {
        return;
      }

      document.body.addEventListener('click', handleDocumentClick);

      state.started = true;
      context.state.moreMenuPanel = { started: true };
    },

    async stop(context) {
      document.body.removeEventListener('click', handleDocumentClick);

      state.toggle = null;
      state.started = false;

      context.state.moreMenuPanel = { started: false };
    },
  };
}
